import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useProfile } from "@/context/ProfileContext";
import { GRADES, gradeLabel } from "@/lib/api";

export const GradeSelect = ({ testId = "grade-select", className = "" }) => {
  const { profile, setGrade } = useProfile();
  if (profile.grade_locked) return (
    <span data-testid={`${testId}-locked`} title="Your grade is set by your parent or teacher" className={`inline-flex items-center justify-center h-10 px-4 rounded-full bg-[#F7F3EB] border border-[#E6DEC3] text-sm text-[#2C4A3E] whitespace-nowrap ${className}`}>{gradeLabel(profile.grade)}</span>
  );
  return (
    <Select value={profile.grade} onValueChange={setGrade}>
      <SelectTrigger data-testid={testId} className={`${className.includes("w-") ? "" : "w-[150px]"} rounded-full bg-[#F7F3EB] border-[#E6DEC3] ${className}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {GRADES.map((g) => (
          <SelectItem key={g} value={g} data-testid={`${testId}-option-${g}`}>{gradeLabel(g)}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
